import styled from 'styled-components';
import {
    mobileMedia,
    scrollbar,
    BGImageCenter,
    tabletMedia
} from '../../../globalVariables/GlobalVariables';
import {ProfileMenuStyledCtr, ProfileMenuStyledClose} from '../../../layout/topMenu/layoutUserProfile/layoutUserProfileMenu/LayoutUserProfileMenu.css';
import fonts from '../fonts';
import {firstPage} from '../../../assets/symbols/images/Images.css';
import {buttonNo} from '../../../component/button/btnAdd/BtnAdd.css';
import {btnPlus, plusIcon} from '../../../component/button/btnPlus/BtnPlus.css';
import {windowBase} from '../style.css';
import {getColor} from '../utils/themeUtils';

export const WINDOW_HEIGHT = '300px';

export const wrapper = styled.div<{ colors?: string[]; }>`
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, #8ED4E5 0%, #FFFFFF 100%);
        opacity: ${p=>p.colors && p.colors.length > 0 ? 0 : 1};
        transition: opacity 400ms;
    }
    transition: all 0.5s;
    height: 100%;
    ${scrollbar};
    color: ${p=>getColor(p.theme.isDarkMode)};
    ${ProfileMenuStyledCtr}{
        &.show{
            top: 0;
        }
        ${tabletMedia}{
            ${ProfileMenuStyledClose}{
                display: block;
            }
        }
    }
 `;

export const baseGrid = styled.div`
 width: 80%;
 margin: 0 auto 20px auto;
 display: grid;
 gap: 20px;
 position: relative;
 ${mobileMedia}{
     gap: 12px;
     width: 96%;
     margin: 10px auto;
}
`;
export const gridTop = styled(baseGrid)`
    grid-template-areas:"profile details";
    grid-template-columns: 263px calc(100% - 283px);
    ${mobileMedia}{
        grid-template-areas:"profile"
                            "details";
        grid-template-columns: 100%;

   }
`;
export const gridContainer = styled(baseGrid)<{ rolePermission? : boolean; }>`
    ${p=>p.rolePermission ? `grid-template-areas:"eventSection eventSection windowsReports"
                                                "accountCash accountCash accountCash";
    grid-template-columns: 1fr 1fr 1fr;`: `grid-template-areas:"eventSection eventSection";
    grid-template-columns: 100%;`} ;
     ${mobileMedia}{
        grid-template-areas:"eventSection"
                             "windowsReports"
                             "accountCash";
        grid-template-columns: 100%;

   }
`;

export const eventSection = styled.div`
    grid-area: eventSection;
    ${windowBase};
    //position: relative;
    padding: 20px;
    height: ${WINDOW_HEIGHT};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${buttonNo}{
        padding-block: 3px;
        padding-inline-start: 3px;
    }
    ${mobileMedia}{
        padding: 12px;
        height: 190px;
        ${btnPlus}{
            width: 30px;
            height: 30px;

        }
        ${plusIcon}{
            width: 29px;
            height: 29px;

        }
    }


`;

export const text = styled.div`
    ${fonts.windowTitle};
    font-size: 18px;
    text-align: center;
    color: ${p=>getColor(p.theme.isDarkMode)};
`;

export const image = styled.div`
  ${BGImageCenter(firstPage,'contain')};
  height: ${WINDOW_HEIGHT};
  width: 600px;
  max-width: 80%;
  margin: 0 auto;
  max-height: calc(100% - 100px);
  ${mobileMedia}{
    height: 77px;
    max-height: unset;
  }
`;
